import { Injectable, OnDestroy, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class QbusLocaleService implements OnDestroy {
  private readonly translate = inject(TranslateService);

  private readonly _locale$ = new BehaviorSubject(
    this.langToLocale(this.translate.currentLang)
  );
  private subscriptions: Subscription[] = [];

  constructor() {
    const subscription = this.translate.onLangChange
      .pipe(map((event) => this.langToLocale(event.lang)))
      .subscribe((locale) => {
        if (this._locale$.value !== locale) this._locale$.next(locale);
      });

    this.subscriptions.push(subscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    this.subscriptions = [];
  }

  /**
   * Return an observable that observes the language from and
   * maps to a locale.
   */
  get locale$() {
    return this._locale$.asObservable();
  }

  get locale() {
    return this._locale$.value;
  }

  private langToLocale(lang: string) {
    if (!lang) return 'en-UK';

    const langId = parseInt(lang[lang.length - 1]);

    switch (langId) {
      case 1:
        return 'nl-BE';
      case 2:
        return 'fr-FR';
      case 3:
      default:
        return 'en-UK';
    }
  }
}
